module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-25.b06125ff.png";